import React from "react";
import { Section, Reveal, Eyebrow, SectionTitle, CTAButton } from "./ui";
import { problems } from "./data";
export function Problems() {
  return <Section id="identificacion" className="bg-white" data-id="element-185" data-mp="36xuc5149vdod">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-186" data-mp="3249dd6uuufo4">
        <Eyebrow data-id="element-187" data-mp="322oghal2ikn3">Cuando no sabés qué probar</Eyebrow>
        <SectionTitle data-id="element-188" data-mp="2y2o1nou247fi">Acompañar no siempre viene con un manual.</SectionTitle>
        <p className="mt-4 text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-189" data-mp="2t4mjr78dae5m">
          Podés tener las mejores intenciones y aun así encontrarte con situaciones en las que
          no sabés qué estrategia probar, cómo responder o por dónde empezar.
        </p>
      </Reveal>

      <ul className="mt-8 grid gap-2.5 sm:mt-10 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3" data-id="element-190" data-mp="2f4uyqmjfnxi4">
        {problems.map((p, i) => <Reveal key={p.text} delay={i % 3 * 0.05} data-id="element-191" data-mp="hdsdue23egjx" data-mpi={i}>
            <li className="flex h-full items-start gap-3 rounded-2xl border border-[#e6eef5] bg-[#fbfdff] p-4 text-left sm:p-5" data-id="element-192" data-mp="dd8gb9dlxax9">
              <span className="text-xl leading-none" aria-hidden data-id="element-193" data-mp="34qlk3gskxjnr">
                {p.emoji}
              </span>
              <p className="text-[13px] leading-snug text-[var(--muted)] sm:text-sm sm:leading-relaxed" data-id="element-194" data-mp="39qzg20gwp35f">
                {p.text}
              </p>
            </li>
          </Reveal>)}
      </ul>

      <Reveal delay={0.1} className="mt-8 text-center sm:mt-10" data-id="element-195" data-mp="2zsjq40tm7zxi">
        <p className="mx-auto max-w-xl font-serif-display text-xl leading-snug text-[var(--ink)] sm:text-2xl" data-id="element-196" data-mp="3nhmjg5xm3h7u">
          No necesitás tener todas las respuestas.
        </p>
        <p className="mx-auto mt-2 max-w-xl text-sm text-[var(--muted)] sm:text-base" data-id="element-197" data-mp="3sia7ciqjnhxu">
          Necesitás más herramientas y un lugar claro donde buscarlas.
        </p>
        <CTAButton className="mt-6" data-id="element-198" data-mp="3ip33517ji7zc">Quiero dejar de improvisar</CTAButton>
      </Reveal>
    </Section>;
}